var $ = jQuery;

$(document).on('cart.requestComplete', function (event, cart) {
    $('span.count').html(cart.item_count);
    addedToCartMessage();
    var requestComplete = true;
    ga('send', {
        hitType: 'event',
        eventCategory: 'Product',
        eventAction: 'addtocart',
        eventLabel: "Item: "
        // nonInteraction: true
    });
    /*fbq('track', 'AddToCart', {
        value: product_price,
        currency: 'USD',
        content_ids: '',
        content_type: 'Product',
    });*/

});

function addedToCartMessage(event) {
    $("#addToCartMessage").slideToggle();
    setTimeout(function() {  $("#addToCartMessage").slideToggle(); }, 10000);
    $('.Product-cart_message_handler').html('<img class="add_to_cart_img" src="//shop.briogeohair.com/cdn/shop/t/407/assets/check.png?v=150825788820980675891743512150" > Item added to your cart! <a href="/cart" title="view cart">View shopping cart</a>').fadeIn().delay(4000).fadeOut();
    $("[data-siteheader-cart-link]").addClass("SiteHeader-cart_link--has_product");
}

$("#continue-shopping-button").click(function(){
    $(this).parent().slideToggle();
})

if($(".message").length) {
    $('.message').hide();
}

$(".quick-view__add-to-cart").click(function(){
    var messageContainer = $(".product_overlay." + $(this).attr("data-product-id")).find('.message');
    messageContainer.show();
    setTimeout(function() { messageContainer.hide(); }, 5000);
})

$('.quick-view__button').magnificPopup({
type:'inline',
midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
});

$(".quick-view__add-to-cart--new").click(function(){
    var messageContainer = $(".product__quick-view-container." + $(this).attr("data-product-id")).find('.quick-view__message');
    messageContainer.slideToggle();
    setTimeout(function() { messageContainer.slideToggle(); }, 5000);
});

function elementLoaded(el, cb) {
    if ($(el).length) {
      cb($(el));
    } else {
      setTimeout(function () {
        elementLoaded(el, cb)
      }, 500);
    }
  };

  $(document).ready(function () {

        $(".faqPanel li").click(function () {
            var panelName = $(this).text();
            ga('send', {
                hitType: 'event',
                eventCategory: 'Single Product Page',
                eventAction: 'click',
                eventLabel: "Information Dropdown Opened"
                // nonInteraction: true
            });
            console.log("Information Dropdown Opened")
        });

        $(".read_all_reviw").click(function () {
            ga('send', {
                hitType: 'event',
                eventCategory: 'Page',
                eventAction: 'click',
                eventLabel: "Read All Reviews Clicked"
                // nonInteraction: true
            });
            console.log("Read All Reviews Clicked")
        });

    });

    $('.portfolio-item img.video').click(function () {
        var videoTitle = $(this).parent().find('h2').text();
        ga('send', {
            hitType: 'event',
            eventCategory: 'Tutorial Videos',
            eventAction: 'play',
            eventLabel: videoTitle
            // nonInteraction: true
        });
    });

    function testimonialOpened(event) {
        ga('send', {
            hitType: 'event',
            eventCategory: 'Testimonials',
            eventAction: 'click',
            eventLabel: "Read More Button Click"
            // nonInteraction: true
        });
    };

    elementLoaded('span:contains("Auto-ship")', function (el) {
        $("span:contains('Auto-ship')").parent().find('input').attr('onclick', 'autoShipSelected')
    });

    function autoShipSelected() {
        ga('send', {
            hitType: 'event',
            eventCategory: 'Single Product Page',
            eventAction: 'click',
            eventLabel: "Auto ship checked"
            // nonInteraction: true
        });
        console.log("Checked");
    };

    $(".remove").click(function(e){
        ga('send', {
            hitType: 'event',
            eventCategory: 'Cart',
            eventAction: 'click',
            eventLabel: "Item Removed From Cart"
            // nonInteraction: true
        });
    });

    $('[data-cart-item] input').change(function(){
        ga('send', {
            hitType: 'event',
            eventCategory: 'Cart',
            eventAction: 'valuechange',
            eventLabel: "Item Quantity In Cart Changed"
            // nonInteraction: true
        });
        console.log("Item Quantity Changed");
    });
